import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=a220c4c2&scoped=true&"
var script = {}
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=a220c4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a220c4c2",
  null
  
)

export default component.exports